export const environmentFlag: string = 'stage';
export const ApiEndPointUrl = setApiEndPoint();
export const MapApiKey = setMapkey();
export const OrderLocations: string =
  environmentFlag == 'stage' ? 'OrderLocations-staging' : 'OrderLocations';
export const OrderPool: string =
  environmentFlag == 'stage' ? 'OrderPool-staging' : 'OrderPool';
export const bulk: string =
  environmentFlag == 'stage' ? 'bulk-staging' : 'bulk';
export const interRegional: string =
  environmentFlag == 'stage'
    ? 'interReginalOrders-staging'
    : 'interReginalOrders';
export const interRegionalOrder: string =
  environmentFlag == 'stage'
    ? 'interReginalOrderPool-staging'
    : 'interReginalOrderPool-production';

// driver tracking
export const liveTraking: string =
  environmentFlag == 'stage' ? 'liveTraking-staging' : 'liveTraking';
export const ordersTracking: string =
  environmentFlag == 'stage' ? 'orders-staging' : 'orders';

export const apiVersionPath =
  environmentFlag == 'stage'
    ? 'https://apistage.phlenu.com/api/common/get-api-version'
    : 'https://api5.phlenu.com/api/common/get-api-version';

export const ghanaWhatsAppLink =
  'https://wa.me/233530460178?text=hello?affiliateId=';
export const nigeriaWhatsAppLink =
  'https://wa.me/2349166329008?text=hello?affiliateId=';

function setApiEndPoint(): string {
  let apiEndPoint;
  switch (environmentFlag) {
    case 'stage':
      apiEndPoint = 'https://apistage.phlenu.com/api/';
      break;

    case 'prod':
      apiEndPoint = 'https://api5.phlenu.com/api/';
      break;

    default:
      apiEndPoint = 'https://apistage.phlenu.com/api/';
  }
  return apiEndPoint;
}

function setMapkey(): string {
  let mapKey;
  switch (environmentFlag) {
    case 'stage':
      mapKey = 'AIzaSyDrl29BNQVeFv93cfa5N6lf2lZ8Bxof2A4';
      break;

    case 'prod':
      mapKey = 'AIzaSyCnWl_m124PuLx2g4cJMEA98cxHvDb7t5k';
      break;
  }
  return mapKey;
}

//
export const shift = 4;

export function encrypt(text, shift) {
  let result = '';

  for (let i = 0; i < text.length; i++) {
    let char = text[i];

    // Check if the character is a letter
    if (char.match(/[a-zA-Z]/)) {
      let code = text.charCodeAt(i);

      // Shift uppercase letters
      if (char >= 'A' && char <= 'Z') {
        code = ((code - 65 + shift) % 26) + 65;
      }
      // Shift lowercase letters
      else if (char >= 'a' && char <= 'z') {
        code = ((code - 97 + shift) % 26) + 97;
      }

      result += String.fromCharCode(code);
    } else {
      // If not a letter, just add the character as it is
      result += char;
    }
  }

  return result;
}

// Function to decrypt a message using Caesar Cipher
export function decrypt(text, shift) {
  return encrypt(text, -shift); // Decryption is just the reverse of encryption
}

export function getTimeStamp(date) {
  const timestamp = new Date(date).getTime(); // in milliseconds
  // const timestampInSeconds = Math.floor(timestamp / 1000); // in seconds/
  return timestamp;
}
